module.exports = __webpack_public_path__ + "src/images/measurements/lowHipCircumference.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/measurements/lowHipCircumference.jpg
// module id = 1152
// module chunks = 0